/**
 * スクロール監視メニュー
 */

const TRIGGER_OFFSET = 110;

export default {
    init: function () {
        document.querySelectorAll('[data-scrollspy]').forEach(container => {
            const navSelector = container.dataset.scrollspy;
            const nav = document.querySelector(navSelector);
            const targets = [];

            // リンクと監視要素のリストを生成
            nav.querySelectorAll('a').forEach(link => {
                const target = document.querySelector(link.getAttribute('href'));
                if (target) {
                    targets.push([link, target]);
                }
            });

            window.addEventListener('scroll', function () {
                let found = targets[0];

                // 要素を逆（下）からループ
                for (let last = targets.length - 1, i = last; i >= 0; i--) {
                    const pair = targets[i];
                    const target = pair[1];
                    const targetRect = target.getBoundingClientRect();

                    // 例外で最後の要素の底辺が画面内に入った場合は優先的に選択
                    // if (i === last && targetRect.bottom < window.innerHeight) {
                    //     found = pair;
                    //     break;
                    // }

                    // 頂点がオフセット以下の最初の要素を選択
                    if (targetRect.top < TRIGGER_OFFSET) {
                        found = pair;
                        break;
                    }
                }

                if (found[0].classList.contains('active')) {
                    return; // 変化なし
                }

                const prev = nav.querySelector('a.active');

                if (prev) {
                    prev.classList.remove('active');
                }

                found[0].classList.add('active');
            });
        });
    }
};
